import { combineReducers } from "redux";
import { authSlice } from "./authSlice";
import settingsSlice from "./settingsSlice";

export default combineReducers({
  auth: authSlice.reducer,
  siteLogo: settingsSlice
})